module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/89.62cf2967.png";